import "../styles/components/Loader.scss";

function Loader() {
    return (
        <div className="Loader">
            <div className="loader">Loading...</div>
        </div>
    );
}

export default Loader;
